import { debugLogReducer } from "../helpers/debugHelper";
import { types } from "../types/types";

const initialState = {
  
  experiences: [],
  
  experience: {},
  experienceSaved: {},
  experienceSelected: {},

  experiencesP: [],
  totalItemsExperienceP: 0,
  totalPagesExperienceP: 0,
  currentPageExperienceP: 0,

  experiencesS: [],
  totalItemsExperienceS: 0,
  totalPagesExperienceS: 0,
  currentPageExperienceS: 0,

  searchTextState: "",

  moreThanOneIsSelected: false,
  numberExperienceSelected: 0,

  isLoadingExperiences: false
};

const countSelected = (list) => list.filter(item => item.isSelected).length;

export const experienceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.EXPERIENCE_START_REGISTER_ADMIN:

      return {
        ...state,
        experienceSaved: action.payload,
      };

    case types.EXPERIENCE_UPDATE:
      if (state.experiencesS.length > 0) {
        return {
          ...state,
          experiencesS: state.experiencesS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          experiencesP: state.experiencesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          experiencesP: state.experiencesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.EXPERIENCE_DELETE:
      if (state.experiencesS.length > 0) {
        return {
          ...state,
          experiencesS: state.experiencesS.filter((usr) => usr.id !== action.payload),
          experiencesP: state.experiencesP.filter((usr) => usr.id !== action.payload),
          experienceSelected: {},
        };
      } else {
        return {
          ...state,
          experiencesP: state.experiencesP.filter((usr) => usr.id !== action.payload),
          experienceSelected: {},
        };
      }

    case types.EXPERIENCE_START_LOADING_PAGINATED:
      return {
        ...state,
        experiencesP: action.payload.experiencesP,
        totalItemsExperienceP: action.payload.totalItems,
        totalPagesExperienceP: action.payload.totalPages,
        currentPageExperienceP: action.payload.currentPage,
      };

    case types.EXPERIENCE_START_LOADING_EXPERIENCE_PAGINATED:
      
      return {
        ...state,
        experiencesS: action.payload.experiencesP,
        totalItemsExperienceS: action.payload.totalItems,
        totalPagesExperienceS: action.payload.totalPages,
        currentPageExperienceS: action.payload.currentPage,
      };

    case types.EXPERIENCE_START_SEARCH_PAGINATED:
      return {
        ...state,
        experiencesS: action.payload.experiencesP,
        totalItemsExperienceS: action.payload.totalItems,
        totalPagesExperienceS: action.payload.totalPages,
        currentPageExperienceS: action.payload.currentPage,
      };

    case types.EXPERIENCE_SELECT:
      return {
        ...state,
        experienceSelected: action.payload,
      };

    case types.EXPERIENCE_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        experiencesS: [],
        totalItemsExperienceS: 0,
        totalPagesExperienceS: 0,
        currentPageExperienceS: 0,

        numberExperienceSelected:0
      };

    case types.EXPERIENCE_CLEAN_PAGINATED:
      return {
        ...state,
        experiencesP: [],
        totalItemsExperienceP: 0,
        totalPagesExperienceP: 0,
        currentPageExperienceP: 0,

      };

    case types.EXPERIENCE_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.EXPERIENCE_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    case types.EXPERIENCE_CLEAN_SAVED:
      return {
        ...state,
        experienceSaved: {},
      };

      /*
    case types.EXPERIENCE_LIST_UPDATE_SELECTED:
      
      if (state.experiencesS.length > 0) {
        return {
          ...state,
          experiencesS: state.experiencesS.map((usr) => (usr.id === action.payload ? { ...usr, isSelected: !usr.isSelected } : usr)),

        };
      }
      break;
      */
     case types.EXPERIENCE_LIST_UPDATE_SELECTED: {
           const id = action.payload;
           const currentSelectedCount = countSelected(state.experiencesS);
           const targetItem = state.experiencesS.find(item => item.id === id);
     
           // Si va a seleccionar uno nuevo y ya hay 9, no hacer nada
           if (!targetItem.isSelected && currentSelectedCount >= 9) return state;
     
           const newExperiences = state.experiencesS.map(item =>
             item.id === id ? { ...item, isSelected: !item.isSelected } : item
           );
     
           const newCount = countSelected(newExperiences);
     
           return {
             ...state,
             experiencesS: newExperiences,
             numberExperienceSelected: newCount,
             moreThanOneIsSelected: newCount > 1
           };
         }
     
         // Selección masiva (Primeros 9 o todos si hay menos)
         case types.EXPERIENCE_SELECT_ALL_LIMIT: {
           const newExperiences = state.experiencesS.map((item, index) => ({
             ...item,
             isSelected: index < 9 // Selecciona solo los primeros 9
           }));
     
           const newCount = countSelected(newExperiences);
     
           return {
             ...state,
             experiencesS: newExperiences,
             numberExperienceSelected: newCount,
             moreThanOneIsSelected: newCount > 1
           };
         }
     
         // Limpiar todo
         case types.EXPERIENCE_CLEAN_ALL_SELECTED: {
           return {
             ...state,
             experiencesS: state.experiencesS.map(item => ({ ...item, isSelected: false })),
             numberExperienceSelected: 0,
             moreThanOneIsSelected: false
           };
         }

             //Clean Without list
    case types.EXPERIENCE_CLEAN_ALL_WITHOUT_LIST: {
      return {
        ...state,
        numberExperienceSelected: 0,
        moreThanOneIsSelected: false
      };
    }

    case types.EXPERIENCE_GET_MORE_THAN_ONE_SELECTED:

    debugLogReducer(":: EXPERIENCE_GET_MORE_THAN_ONE_SELECTED");

      if (state.experiencesS.length > 0) {
        return {
          ...state,
          moreThanOneIsSelected: getMoreThanOneIsSelected(state)
        };
      }
      break;

    case types.EXPERIENCE_LIST_SET_NUMBER_SELECTED:
      debugLogReducer(":: EXPERIENCE_LIST_SET_NUMBER_SELECTED");

      if (state.experiencesS.length > 0) {
        return {
          ...state,
          numberExperienceSelected: action.payload
        };
      }
      break;

    case types.EXPERIENCE_CLEAN_SEARCH_INFORMATION:
      debugLogReducer(":: EXPERIENCE_CLEAN_SEARCH_INFORMATION");
      return {
        ...state,
        numberExperienceSelected: 0
      };

        case types.EXPERIENCE_IS_LOADING:

        return {
          ...state,
          isLoadingExperiences: true
        };
    
      case types.EXPERIENCE_IS_LOADING_FINISH:

        return {
          ...state,
          isLoadingExperiences: false
        };

    default:
      return state;
  }
};

const getMoreThanOneIsSelected = (state) => {

  debugLogReducer(":: getMoreThanOneIsSelected");

  let flagMoreThanOne = false;
  let counterFlagMoreThanOneIsSelected = 0;

  if (state.experiencesS.length > 0) {
    state.experiencesS.forEach(element => {

      if (element.isSelected) {
        counterFlagMoreThanOneIsSelected = counterFlagMoreThanOneIsSelected + 1;
      }
    });
  }

  if (counterFlagMoreThanOneIsSelected > 1) {
    flagMoreThanOne = true;
  }

  return flagMoreThanOne;
}